import { Observer } from "mobx-react-lite"
import React, { ReactElement } from "react"
import { PageType, StockSubType } from "../../shared/pagetype"
import { quotedata } from "../../shared/quotedata"
import { ABPrice } from "./ab_price";
// import { ACHPrice } from "./ach_price";
import { AHPrice } from "./ah_price";
import { KZZPrice } from "./kzz_price";

// A股滚动数据签（可转债、H股、B股、瑞士GDR出现其二则循环滚动显示）
export function RollPrice(props: { pagetype: PageType; quotedata: quotedata; stocksubtype: StockSubType,detail_data:any}) {
  let rollElements: Array<ReactElement> = []
  if (props.detail_data?.f256 && props.detail_data.f256 != "-") {
    rollElements.push(<AHPrice pagetype={props.pagetype} />)
  }
  if (props.detail_data?.f264 && props.detail_data.f264 != "-") {
    rollElements.push(<KZZPrice quotedata={props.quotedata} pagetype={props.pagetype} detail_data={props.detail_data} stocksubtype={props.stocksubtype} />)
  }
  if (props.detail_data?.f269 && props.detail_data.f269 != "-") {
    rollElements.push(<ABPrice pagetype={props.pagetype} />)
  }
  // if (props.detail_data?.f747 && props.detail_data.f747 != "-") {
  //   rollElements.push(<ACHPrice pagetype={props.pagetype} />)
  // }
  
  return (
    <Observer>
      {() => (
        <>
          {rollElements.length > 1 ? (
            <div className="roll-container">
              <div className="roll-wrap">
                {rollElements.map((v: any, index:number) => {
                  return (
                    <ul className="roll-list" key={index}>
                      <li className="roll-item">{v}</li>
                    </ul>
                  )
                })}
                {rollElements.map((v: any, index:number) => {
                  return (
                    <ul className="roll-list" key={index}>
                      <li className="roll-item">{v}</li>
                    </ul>
                  )
                })}
              </div>
            </div>
          ) : (
            <>{rollElements[0]}</>
          )}
        </>
      )}
    </Observer>
  )
}
